/**
 * Currency formatting utilities for Tebex price display
 */

const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: 'CA$',
  AUD: 'A$',
  NZD: 'NZ$',
  CHF: 'CHF ',
  SEK: 'kr ',
  NOK: 'kr ',
  DKK: 'kr ',
  PLN: 'zł ',
  BRL: 'R$',
  MXN: 'MX$',
  JPY: '¥',
  CNY: '¥',
  KRW: '₩',
  INR: '₹',
  RUB: '₽',
  TRY: '₺',
  ZAR: 'R ',
};

/**
 * Get the currency symbol for a given currency code
 * @param {string} currencyCode - ISO 4217 currency code (e.g., 'USD', 'EUR')
 * @returns {string} Currency symbol or code prefix if unknown
 */
export function getCurrencySymbol(currencyCode) {
  return CURRENCY_SYMBOLS[currencyCode] || currencyCode + ' ';
}

/**
 * Format a price with the correct currency symbol
 * @param {number} amount - The numeric price amount
 * @param {string} currencyCode - ISO 4217 currency code
 * @returns {string} Formatted price string (e.g., '$50.00', '€43.00')
 */
export function formatPrice(amount, currencyCode) {
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol}${(amount || 0).toFixed(2)}`;
}
